import React, {useRef,useState, useLayoutEffect} from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import "./workSection.css";
import htmlParser from "html-react-parser";
import ellipse from "../../images/ellipse.webp";
// import GirlImage from "../../images/body-girl.webp";


export default function WorkSection({workData, handleOnClick }) {

const imgURL = process.env.REACT_APP_CDN_URL;

const handleButtonClick = () => {
    handleOnClick();
  };

  return (
      <>
      <div className="workSection">
        <img src={ellipse} className="ellipse" width={"80px"}/>
        <Container>
         
          <Row>
            <Col sm={12} md={12} lg={8} xl={8}>
            <div className="bgblue" />
            <h4 className="workHeading">{htmlParser(workData.workHeading)}</h4>
               <p className="workText">{htmlParser(workData.workText)}</p>
                <ol>
                <li className="listText">{htmlParser(workData.worktext1)}</li>

                <li className="listText">{htmlParser(workData.worktext2)}</li>

                <li className="listText">{htmlParser(workData.worktext3)}</li>
                </ol>
              
              </Col>
              <Col sm={12} md={12} lg={4} xl={4}>
                <Image src={imgURL + "body-girl.webp"} className="systemImage"/>
               
                <div className="bgblue1"/>
                {/* <p className="workTextmob">{htmlParser(workData.workText)}</p> */}
              </Col>
          </Row>
        </Container>
        </div>
      </>
    );
  
  }

